import * as React from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import ReactPaginate from 'react-paginate'

import BrandOrderCardNew from '../../components/BrandOrderCardNew/BrandOrderCardNew'
import BrandOrderListNew from '../../components/BrandOrderListNew/BrandOrderListNew'
import SearchSection from '../../components/SearchSection/search-section'

import { SearchParameters, config as typesenseConfig, typesenseQuery } from '../../../../typeSense'
import { getDashboardId } from '../../../../helpers/getDashboardId'

import {
  OrdersHeader,
  BrandOrderCards,
  SectonTitle,
  NavbarStyles,
  Shitcher,
  Switch,
  Pagination,
  ContentWrapper,
} from './brand-orders-new.style'

interface BrandOrdersNewProps {
  brandId?: string
  brandOrderUuid?: string
  searchToken?: string
}

const BrandOrdersNew: React.FC<BrandOrdersNewProps> = ({ brandOrderUuid, searchToken }) => {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('')
  const [searchTerm, setSearchTerm] = React.useState('')
  const [optionDropdownData, setOptionDropdownData] = React.useState<any>([])
  const [projectsDataTS, setProjectsDataTS] = React.useState<any>([])
  const [projectsCount, setProjectsCount] = React.useState<number>(0)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [sorting, setSorting] = React.useState<any>([])

  const prevState = React.useRef<string[]>([])
  const localStorageView = typeof localStorage !== 'undefined' ? localStorage.getItem('view') : null
  const [isListView, setIsListView] = React.useState(localStorageView === 'list' || false)
  const isMounted = React.useRef(true)

  const gridActiveSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="42" viewBox="0 0 58 42" fill="none">
      <rect width="58" height="42" rx="8" fill="#1E1E21" />
      <rect
        x="17.75"
        y="11.75"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <rect
        x="17.75"
        y="22.4642"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <rect
        x="30.6094"
        y="11.75"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <rect
        x="30.6094"
        y="22.4644"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  )
  const gridPassiveSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="42" viewBox="0 0 58 42" fill="none">
      <rect x="0.5" y="0.5" width="57" height="41" rx="7.5" fill="white" />
      <rect x="0.5" y="0.5" width="57" height="41" rx="7.5" stroke="#E9E9E9" />
      <rect
        x="17.75"
        y="11.75"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="#1E1E21"
        strokeWidth="1.5"
      />
      <rect
        x="17.75"
        y="22.4642"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="#1E1E21"
        strokeWidth="1.5"
      />
      <rect
        x="30.6094"
        y="11.75"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="#1E1E21"
        strokeWidth="1.5"
      />
      <rect
        x="30.6094"
        y="22.4644"
        width="9.92857"
        height="7.78571"
        rx="1.25"
        stroke="#1E1E21"
        strokeWidth="1.5"
      />
    </svg>
  )
  const listActiveSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="42" viewBox="0 0 58 42" fill="none">
      <rect width="58" height="42" rx="8" fill="#1E1E21" />
      <rect
        x="17.75"
        y="11.75"
        width="7.8913"
        height="7.5"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <rect x="28.4766" y="13" width="12.5217" height="1.5" rx="0.75" fill="white" />
      <rect x="28.4766" y="16" width="6.26087" height="1.5" rx="0.75" fill="white" />
      <rect
        x="17.75"
        y="22.75"
        width="7.8913"
        height="7.5"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <rect x="28.4766" y="24" width="12.5217" height="1.5" rx="0.75" fill="white" />
      <rect x="28.4766" y="27" width="6.26087" height="1.5" rx="0.75" fill="white" />
    </svg>
  )
  const listPassiveSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="42" viewBox="0 0 58 42" fill="none">
      <rect x="0.5" y="0.5" width="57" height="41" rx="7.5" fill="white" />
      <rect x="0.5" y="0.5" width="57" height="41" rx="7.5" stroke="#E9E9E9" />
      <rect
        x="17.75"
        y="11.75"
        width="7.8913"
        height="7.5"
        rx="1.25"
        stroke="#1E1E21"
        strokeWidth="1.5"
      />
      <rect x="28.4766" y="13" width="12.5217" height="1.5" rx="0.75" fill="#1E1E21" />
      <rect x="28.4766" y="16" width="6.26087" height="1.5" rx="0.75" fill="#1E1E21" />
      <rect
        x="17.75"
        y="22.75"
        width="7.8913"
        height="7.5"
        rx="1.25"
        stroke="#1E1E21"
        strokeWidth="1.5"
      />
      <rect x="28.4766" y="24" width="12.5217" height="1.5" rx="0.75" fill="#1E1E21" />
      <rect x="28.4766" y="27" width="6.26087" height="1.5" rx="0.75" fill="#1E1E21" />
    </svg>
  )

  const localStorageSearchTerm = localStorage.getItem('searchTerm')

  const flags = useFlags()
  const listView = flags['brand-dashboard-new-list-view']

  const projectsPerPage = 60

  const sortingCallbackFunction = React.useCallback(
    () => {
      const sortName = sorting.name
      const sortSeq = sorting.seq
      if (sortName === '' || sortSeq === '' || sortName === undefined || sortSeq === undefined) {
        return undefined
      }
      if (sortName === 'location') {
        return
      }
      return `${sortName}:${sortSeq}`
    },
    [sorting]
  )

  const TSCollection =
    window.env && window.env.ENVIRONMENT === 'production' ? 'orders' : 'orders_staging'

  const excludeLost = '&&state:!=Lost'
  const typeSenseQuery = () => {
    const filteredStatus =
      prevState.current &&
      `&&projectStatus:[${prevState.current
        .map(item => item !== undefined && item !== null && item !== 'false' && item)
        .join(',')}]`

    const searchParameters: SearchParameters = {
      q: debouncedSearchTerm,
      query_by:
        'name,orderId,locations.address,locations.cityName,locations.countryName,locations.countryCode,paymentType,projectStatus, orderId, vaasId',
      sort_by: sortingCallbackFunction(),
      filter_by: `organisations.id:${getDashboardId()}${excludeLost}${filteredStatus}`,
      per_page: projectsPerPage.toString(),
      page: currentPage.toString(),
    }

    searchToken !== '' &&
      prevState.current.length > 0 &&
      typesenseQuery(searchToken || '', typesenseConfig, TSCollection, searchParameters)
        .then(result => {
          setProjectsDataTS(result.hits.map(hit => hit.document))
          setProjectsCount(result.found)
        })
        .catch(error => console.error('Failed to query Typesense:', error))
  }

  React.useEffect(
    () => {
      typeSenseQuery()
    },
    [debouncedSearchTerm, sorting, currentPage]
  )

  React.useEffect(() => {
    document.body.classList.add('dashboard')
    setSearchTerm(localStorageSearchTerm || '')
    return () => {
      document.body.classList.remove('dashboard')
    }
  }, [])
  const paginationArrow = `https://res.cloudinary.com/ninety-seconds/image/upload/v1632296457/-homepage-icons/arrow-right.svg`

  React.useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  // Debounce the search to stop jerky results.
  React.useEffect(
    () => {
      const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300)
      return () => clearTimeout(handler)
    },
    [searchTerm, setDebouncedSearchTerm]
  )

  return (
    <>
      <NavbarStyles />
      <OrdersHeader>
        <h3 data-testid="header-title">Dashboard</h3>
        {listView && (
          <Shitcher>
            <Switch
              onClick={() => {
                setIsListView(false)
                localStorage.setItem('view', 'grid')
              }}
            >
              {!isListView ? gridActiveSvg : gridPassiveSvg}
            </Switch>
            <Switch
              onClick={() => {
                localStorage.setItem('view', 'list')
                setIsListView(true)
              }}
            >
              {isListView ? listActiveSvg : listPassiveSvg}
            </Switch>
          </Shitcher>
        )}
      </OrdersHeader>
      <SearchSection
        onChange={e => setSearchTerm(e.target.value)}
        onClearInput={() => setSearchTerm('')}
        onOptionChange={e => setOptionDropdownData(e)}
        onStatusChange={e => {
          prevState.current = e
          typeSenseQuery()
        }}
        placeholder="Find Order"
        hideButton
        options
        searchToken={searchToken}
        brandOrderUuid={brandOrderUuid}
      />
      <ContentWrapper hidden={!isListView}>
        <BrandOrderListNew
          projects={projectsDataTS}
          brandOrderUuid={brandOrderUuid}
          optionDropdownData={optionDropdownData}
          projectsCount={projectsCount}
          sortStateCallback={data => setSorting(data)}
        />
      </ContentWrapper>
      <ContentWrapper hidden={isListView}>
        <SectonTitle>Orders</SectonTitle>
        <BrandOrderCards>
          {projectsDataTS.map((project, index) => {
            return (
              <BrandOrderCardNew
                project={project}
                key={`grid-${project.id}-${index}`}
                brandOrderUuid={brandOrderUuid}
              />
            )
          })}
        </BrandOrderCards>
      </ContentWrapper>
      <Pagination>
        <ReactPaginate
          breakLabel="..."
          nextLabel={<img src={paginationArrow} alt="arrow" />}
          onPageChange={e => setCurrentPage(e.selected + 1)}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={Math.ceil(projectsCount / projectsPerPage)}
          previousLabel={<img src={paginationArrow} alt="arrow" />}
          renderOnZeroPageCount={null}
        />
      </Pagination>
    </>
  )
}

export default BrandOrdersNew



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardOrdersNew/BrandTeamNew/brand-orders-new.tsx